import { useEffect, useState } from 'react';
import { DESKTOP_BREAKPOINT_PX } from '../../common/constants/breakpoints';

export function useIsDesktop(): boolean {
    const query = `(min-width: ${DESKTOP_BREAKPOINT_PX}px)`;
    const [isDesktop, setIsDesktop] = useState(
        () => typeof window !== 'undefined' && window.matchMedia(query).matches
    );

    useEffect(() => {
        const mql = window.matchMedia(query);
        const handler = (e: MediaQueryListEvent) => setIsDesktop(e.matches);
        mql.addEventListener('change', handler);
        return () => mql.removeEventListener('change', handler);
    }, [query]);

    return isDesktop;
}
